import * as types from './Punchout.types';
import * as selectors from './Punchout.selectors';
import * as loginActions from './../Login/Login.actions';
import axios from 'axios';
import { showNotification } from './../../utils';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchSession = (id) => (dispatch, getState) => {
    dispatch({ type: types.FETCH_SESSION, payload: null });
    axios.get(apiUrl + '/cxml-punchouts/' + id,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_SESSION_SUCCESS, payload: response.data });

            // if (parseInt(response.data.id) !== 16) {
                dispatch(loginUser());
            // }
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_SESSION_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                // dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const loginUser = () => (dispatch, getState) => {
    const session = selectors.getSession(getState());
    const history = selectors.getHistory(getState());

    localStorage.removeItem('cxml_id');
    localStorage.removeItem('cxml_first_name');
    localStorage.removeItem('cxml_last_name');
    localStorage.removeItem('cxml_email');
    localStorage.removeItem('cxml_buyer_cookie');
    localStorage.removeItem('cxml_browser_form_post');

    dispatch({ type: types.LOGIN, payload: null });
    axios.post(apiUrl.replace('/v1', '') + '/oauth2/token',
        {
            grant_type: 'password',
            client_id: 'testclient',  // TODO: Add this to environment variables
            client_secret: 'testpass',  // TODO: Add this to environment variables
            username: 'uthealth.punchout',
            password: session.buyer_id,
            loginType: 'uth-coupa',
            buyer_cookie: session.buyer_cookie,
            buyer_id: session.buyer_id,
        })
        .then(response => {
            dispatch({
                type: types.LOGIN_SUCCESS,
                payload: response.data
            });
            dispatch(loginActions.setTokens(response.data));

            let cxml_data = {
                id: null,
                first_name: null,
                last_name: null,
                email: null,
                buyer_cookie: null,
                browser_form_post: null,
                supplier_domain: null,
                supplier_id: null,
                buyer_domain: null,
                buyer_id: null,
            };

            const extrinsicData = JSON.parse(session.extrinsic);
            if (extrinsicData && extrinsicData.FirstName) {
                cxml_data.first_name = extrinsicData.FirstName;
                localStorage.setItem('cxml_first_name', extrinsicData.FirstName);
            }
            if (extrinsicData && extrinsicData.LastName) {
                cxml_data.last_name = extrinsicData.LastName;
                localStorage.setItem('cxml_last_name', extrinsicData.LastName);
            }
            if (extrinsicData && extrinsicData.UserEmail) {
                cxml_data.email = extrinsicData.UserEmail;
                localStorage.setItem('cxml_email', extrinsicData.UserEmail);
            }
            
            cxml_data.id = session.id;
            localStorage.setItem('cxml_id', session.id);

            cxml_data.buyer_cookie = session.buyer_cookie;
            localStorage.setItem('cxml_buyer_cookie', session.buyer_cookie);

            cxml_data.browser_form_post = session.browser_form_post;
            localStorage.setItem('cxml_browser_form_post', session.browser_form_post);

            cxml_data.supplier_domain = session.supplier_domain;
            localStorage.setItem('cxml_supplier_domain', session.supplier_domain);

            cxml_data.supplier_id = session.supplier_id;
            localStorage.setItem('cxml_supplier_id', session.supplier_id);

            cxml_data.buyer_domain = session.buyer_domain;
            localStorage.setItem('cxml_buyer_domain', session.buyer_domain);

            cxml_data.buyer_id = session.buyer_id;
            localStorage.setItem('cxml_buyer_id', session.buyer_id);

            dispatch(loginActions.setCxmlData(cxml_data));

            history.push('/');
        })
        .catch(error => {
            dispatch({ type: types.LOGIN_ERROR, payload: null });
            showNotification('Incorrect Credentials', 'The email or password are incorrect', 'info');
        });
}

export const setHistory = (history) => (dispatch) => {
    dispatch({
        type: types.SET_HISTORY,
        payload: history,
    });
}

export const setEmail = (value) => (dispatch) => {
    dispatch({
        type: types.SET_EMAIL,
        payload: value,
    });
}